import { useI18n } from "../i18n"

type DateInput = string | number | Date

export const formatDateSlot = (startTime: DateInput, endTime: DateInput) => {
  const { getI18n } = useI18n()
  const Time = (timeStamp: DateInput) => {
      const date = new Date(timeStamp)
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      const amOrPm = hours > 11 ? getI18n()?.formatMessage({ id: 'PM' }) : getI18n()?.formatMessage({ id: 'AM' })

      hours = hours % 12
      hours = hours ? hours : 12
      return hours + ':' + minutes + ' ' + amOrPm
  }
  let dateSlot = ''

  const startdate = new Date(startTime)
  const yyyy = startdate.getFullYear()
  const month = startdate.getMonth() + 1 // Months start at 0!
  const mm = month < 10 ? '0' + month : month
  const dd = startdate.getDate() < 10 ? '0' + startdate.getDate() : startdate.getDate()
  const programDate = dd + '/' + mm + '/' + yyyy

  if (new Date().setHours(0, 0, 0, 0) !== startdate.setHours(0, 0, 0, 0)) {
    dateSlot = programDate + ' : '
  }

  dateSlot += Time(startTime) + ' - ' + Time(endTime)

  return dateSlot
}

export const formatFullDateSlot = (startTime: DateInput, endTime: DateInput) => {
  const Time = (timeStamp: DateInput) => {
      const date = new Date(timeStamp)
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      const amOrPm = hours > 11 ? 'pm' : 'am'

      hours = hours % 12
      hours = hours ? hours : 12
      return hours + ':' + minutes +':'+ seconds + ' ' + amOrPm
  }
  let dateSlot = ''

  const startdate = new Date(startTime)
  const yyyy = startdate.getFullYear()
  const month = startdate.getMonth() + 1 // Months start at 0!
  const mm = month < 10 ? '0' + month : month
  const dd = startdate.getDate() < 10 ? '0' + startdate.getDate() : startdate.getDate()
  const programDate = dd + '/' + mm + '/' + yyyy

  if (new Date().setHours(0, 0, 0, 0) !== startdate.setHours(0, 0, 0, 0)) {
    dateSlot = programDate + ' : '
  }

  dateSlot += Time(startTime) + ' - ' + Time(endTime)

  return dateSlot
}